<template>
    <div class="client">
        <div class="client-photo">
            <picture>
                <source :srcset="require(`@/assets/img/respondents/${client.imgUrl}`)" type="image/webp">
                <img :alt="client.name" :src="require(`@/assets/img/respondents/${client.imgClassicUrl}`)" />
            </picture>
        </div>
        <v-headline :level="3" class="client-name">{{client.name}}</v-headline>
        <p class="client-rank text-t">{{client.rank}}</p>
        <p class="client-comment text-t">{{client.comment}}</p>
    </div>
</template>

<script>
import VHeadline from "@/components/ui/VHeadline";
export default {
    components: {
        VHeadline
    },
    props: {
        client: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped lang="scss">
.client {
    margin: 20px 0;
    max-width: 990px;
    margin: 0 auto;
    padding: 15px;
    text-align: left;

    color: white;

    &-photo {
        float: left;
        padding-right: 10px;
        padding-bottom: 5px;
        img {
            border-radius: 100px;
        }
    }

    &-rank {
        padding: 15px 0;
    }

    &-comment, &-rank {
        line-height: 1.5;
    }

    &-name {
        text-transform: uppercase;
        font-weight: 600;
        padding: 5px 0 10px 0;
    }
}
</style>